import React from "react";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";
import { ArrowRight } from "react-bootstrap-icons";
import { OurworksContent } from "../../../../Constants/content";
import { GoArrowUpRight } from "react-icons/go";

const OurWorksSection = () => {
  return (
    <Container className="py-5">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
        <div>
          <h6 className="text-dark fw-semibold mb-2">Our Works</h6>
          <h2
            className="fw-bold mb-0"
            style={{
              background: "linear-gradient(to right, #0070c9, #004e92)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              lineHeight: "1.3",
            }}
          >
            See How We Turn Ideas Into <br className="d-none d-md-block" />
            Impactful Web Experiences.
          </h2>
        </div>
        <Button
          variant="light"
          className="fw-semibold mt-3 mt-md-0"
          style={{
            backgroundColor: "#d6df1e",
            color: "#000",
            border: "none",
            borderRadius: "30px",
            padding: "0.5rem 1.2rem",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          View All Works <ArrowRight />
        </Button>
      </div>

      {/* Cards */}
      <Row xs={1} md={1} xl={2} className="g-4">
        {OurworksContent.map((project, idx) => (
          <Col key={idx} >
           
            <Card
              className="h-100 custom-work-card rounded-4 shadow-sm overflow-hidden"
              style={{
                background: project.gradient,
                border: "2px solid rgb(114, 113, 113)",
              }}
            >
              {/* Show image first on small screens, second on md+ */}
              <div className="d-md-none">
                <Card.Img
                  src={project.image}
                  alt={project.title}
                  className="img-fluid rounded-top-4"
                  style={{ width: "100%", height: "auto", objectFit: "cover" }}
                />
              </div>

              <Row>
                <Col
                  xs={12}
                  className="p-4 pb-0 d-flex justify-content-between align-items-center"
                >
                  <Badge
                    bg="light"
                    text="dark"
                    className="px-3 py-2 rounded-pill fw-semibold"
                  >
                    Development Project
                  </Badge>
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      backgroundColor: "#fff",
                      width: "36px",
                      height: "36px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    }}
                  >
                    <GoArrowUpRight size={23} />
                  </div>
                </Col>
              </Row>

              <Row className="g-0 align-items-center">
                {/* Content Column */}
                <Col
                  md={7}
                  className="p-4 d-flex flex-column justify-content-between"
                >
                  <div>
                    <Card.Title className="fw-bold fs-5 mb-2">
                      {project.title}
                    </Card.Title>
                    <Card.Text
                      className="text-muted"
                      style={{ textAlign: "justify", fontSize: "14px" }}
                    >
                      {project.description.length > 100
                        ? `${project.description.slice(0, 110)}...`
                        : project.description}
                    </Card.Text>
                  </div>
                  <div className="d-flex justify-content-between align-items-baseline mt-3">
                    <Button
                      variant="link"
                      className="p-0 text-dark fw-semibold d-flex align-items-center gap-1"
                    >
                      Know more <ArrowRight />
                    </Button>
                  </div>
                </Col>

                {/* Image Column (for md and above only) */}
                <Col md={5} className="d-none d-md-block">
                  <Card.Img
                    src={project.image}
                    alt={project.title}
                    className="img-fluid rounded-end-4"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default OurWorksSection;
